<template>
  <div>
    <p class="title">{{$t('tenantProjects.final-docs.history')}}</p>
    <HKLTable
      :dataSource="dataSource"
      :columns="columns"
    />
  </div>
</template>
<script>
import { computed, unref } from 'vue-demi'
import HKLTable from '../../../../controls/Table/HKLTable'
import i18n from '../../../../utils/i18n'
import dateUtil from '../../../../utils/dateUtil'
import { FINAL_DOC_STATUS } from '../../consts'
import { useFinalDocHistories } from './hook'

export default {
  components: {
    HKLTable,
  },
  setup () {
    const histories = useFinalDocHistories()
    const dataSource = computed(() => {
      return unref(histories)
        .filter((res) =>
          [FINAL_DOC_STATUS.EXEMPTED, FINAL_DOC_STATUS.COMPLETED, FINAL_DOC_STATUS.SEND_REMINDER].includes(res.status),
        )
    })
    const columns = computed(() => [
      {
        title: i18n.t('tenantProjects.final-docs.date'),
        dataIndex: 'createdAt',
        render: (val) => dateUtil.formatDate(val, true),
        width: 270,
      }, {
        title: i18n.t('tenantProjects.final-docs.action'),
        dataIndex: 'status',
        render: (val) => i18n.t(`status.${val}`.toLocaleLowerCase()),
        width: 250,
      }, {
        title: i18n.t('tenantProjects.final-docs.actionBy'),
        dataIndex: 'who',
        render: (val) => val && val.displayName,
        width: 270,
      }, {
        title: i18n.t('tenantProjects.final-docs.comment'),
        dataIndex: 'detail',
        render: (val) => val && val.comments,
      },
    ])
    return {
      dataSource,
      columns,
    }
  },
}
</script>
<style scoped>
.title {
  height: 25px;
  font-weight: bold;
}
.hkl-table {
  margin-left: 0;
  margin-right: 0;
}
</style>
